import React, { useState, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { InputOtp } from 'primereact/inputotp';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next';
import HeaderTop from '@ms/shared/components/frame/header';
import '../style/global.css';
import { validateApplication } from '@ms/shared/services/api/register';

const VerifyCode = () => {
    const { t } = useTranslation();
    const [code, setCode] = useState();
    const toast = useRef(null);

    const handleVerify = async (e) => {
       e.preventDefault()
        let payload = {
			application_id: localStorage.getItem('app_id'),
			otp_code: code,
		}
        let result = await validateApplication(payload)

		if (result.status >= 200 && result.status <= 250) {
			await Swal.fire({
				icon: 'success',
				text: t('auth.verify.success'),
			})
            localStorage.clear();
			window.location.replace('/login')
		} else {
			await Swal.fire({
				icon: 'error',
				text: result.data.message,
			})
		}
    };

    return (
        <>
            <HeaderTop/>
            <Container className="mt-5">
                <Toast ref={toast} />
                <Row className="justify-content-md-center">
                    <Col xs={12} md={6}>
                        <h3 className="text-center mb-4 text-color-ms">{t('auth.verify.title')}</h3>
                        <div className="p-inputgroup mb-3">
                            <InputOtp
                                length={6}
                                value={code} 
                                onChange={(e) => setCode(e.value)} 
                                placeholder={t('auth.verify.placeholder')} 
                            />
                        </div>
                        <div className="d-grid">
                            <Button className="bg-green" label={t('auth.verify.submit')} onClick={handleVerify} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default VerifyCode;
